import Vue from 'vue'
import Cognito from './cognito'

Vue.use(Cognito, process.env.COGNITO)

export default new Cognito()



// WEBPACK FOOTER //
// ./src/cognito/index.js